/// <reference path="../../../teva/dropdown/dropdown.ts" />
/// <reference path="../../../teva/positioning/positioning.ts" />
/// <reference path="../../../teva/htmlhelpers/htmlhelpers.ts" />
/// <reference path="../modals/modals.ts" />
/// <reference path="../forms/forms.ts" />
/// <reference path="../navigation/navigation.ts" />
/// <reference path="../notifications/notifications.ts" />
/// <reference path="../externalprovider/externalprovider.ts" />

namespace OfficeGuy {
    interface AjaxRequestParameters {
        URL: string;
        Data?: any;
        SuccessMethod?: any;
        ErrorMethod?: any;
        SkipAjaxErrorMethod?: boolean;
        ShowLoading?: boolean;
        Method?: string;
        ContentType?: any;
        ProcessData?: any;
        RetriesPending?: number;
    }

    export class Common {
        static RootURL = '/';
        static FullRootURL = "https://app.sumit.co.il";
        static LoggedUserID: number;
        static LoggedCompanyID: number;
        static PageType: number;
        static IsPost: number;
        static AntiForgeryToken: string;
        static TooltipID = 0;
        static LastVisitedURL: string;
        static Initialized: boolean = false;
        static LastError: string;
        static JSFileHash: number;

        static Init(): void {
            $.validator.setDefaults({
                ignore: ":hidden:not(.teva-selectbox-hiddeninput)"
            });
            $.validator.methods.date = function (value, element) {
                if (this.optional(element) && value == "")
                    return true;
                if (Globalize.parseDate(value))
                    return true;
                return false;
            };

            Common.Tooltip_Init();

            if (typeof (Globalize) != 'undefined')
                (<any>Globalize).culture("he-IL");

            Teva.Resources.CurrentCulture = document.documentElement.lang;
            $(document).trigger("Teva.Init");

            window.onerror = function (Message, URL, LineNumber, ColumnNumber, Error) {
                try {
                    if (LineNumber == 0 && ColumnNumber == 0)
                        return false;

                    var ErrorMessage = Message + "\r\nPage URL: " + window.location.href;
                    if (Common.LastError == ErrorMessage)
                        return false;

                    Common.LastError = ErrorMessage;
                    ErrorMessage += "\r\nURL: " + URL;
                    ErrorMessage += "\r\nUserAgent: " + navigator.userAgent;
                    ErrorMessage += "\r\nLine: " + LineNumber + ", Column: " + ColumnNumber;
                    ErrorMessage += "\r\nError: " + Error;
                    if (Error.stack != undefined)
                        ErrorMessage += "\r\Stack Trace: " + Error.stack;
                    Common.AjaxRequest({
                        URL: "/error_javascript/",
                        Data: {
                            Message: ErrorMessage
                        },
                        ShowLoading: false
                    });
                    return false;
                }
                catch (E) {
                    console.log(E);
                }
            }
        }

        static PageLoad($Container = null, CompanyID = 0, UserID = 0, JSFileHash = 0, PageType = null): void {
            $(function () {
                if (CompanyID != null && CompanyID != 0 && Common.LoggedCompanyID != null && Common.LoggedCompanyID != CompanyID) {
                    window.location.href = window.location.href;
                    return;
                }
                if (CompanyID != null && CompanyID != 0)
                    Common.LoggedCompanyID = CompanyID;
                if (UserID != null && UserID != 0)
                    Common.LoggedUserID = UserID;
                if (PageType != null)
                    Common.PageType = PageType;

                var IsInitialization = !Common.Initialized;
                if (!Common.Initialized) {
                    Common.Initialized = true;
                    Common.JSFileHash = JSFileHash;
                    OfficeGuy.Common.Init();
                }
                else if (JSFileHash > Common.JSFileHash) {
                    if ($("form input:visible:not(.form-hidden-submit):not(.entities-checkbox), form select, .modal").length == 0)
                        window.location.href = window.location.href;
                    //Common.ShowJSFileHashWarning();
                }

                Common.LastVisitedURL = window.location.href;
                Common.InitEditors($Container);

                $(document).trigger("Teva.PageLoad", IsInitialization);

                $("html, body").scrollTop(0);
                $("#main-inner").scrollTop(0);
                if (!Common.IsBrowserLowResolution())
                    Teva.Navigation.FocusOnFirstField("#main-inner", true);

                Common.Tooltip_PageLoad();

                $(window).trigger("resize.accounting-documents");
            });
        }
        static ShowJSFileHashWarning() {
            Modals.ShowConfirmDialog({
                Title: "הגיע הזמן לעדכון",
                Message: "מערכת SUMIT עודכנה לאחרונה.<br />על מנת להמשיך ולהשתמש במערכת, יש לבצע טעינה מחדש של דף זה.<br />במקרים חוזרים, ניתן ליצור קשר עם צוות התמיכה באמצעות הדוא\"ל <a style=\"color:#212121;\" href=\"mailto:support@sumit.co.il\" target=\"_blank\">support@sumit.co.il</a>.",
                ConfirmText: "לגרסה המעודכנת ביותר",
                ConfirmEvent: function () {
                    window.location.href = window.location.href;
                }
            });
        }
        static InitEditors($Container = null): void {
            $(document).trigger("Teva.InitEditors", $Container);
            Common.InitBottomFade($Container);
        }

        static IsRightToLeft() {
            return document.body.dir == "rtl";
        }

        static IsBrowserLowResolution(): boolean {
            return window.innerWidth <= 850;
        }

        static ToggleScroll($Button, $Element): boolean {
            var Shown = $Element.css("display") == "none";
            $Element.slideToggle();
            if (Shown) {
                Teva.Positioning.ScrollToElement($Button);
                return true;
            }
            else
                return false;
        }

        static Tooltip_Init(): void {
            if ('ontouchstart' in window && navigator.userAgent.toLowerCase().match(/(iphone|ipod|ipad)/))
                return;

            $(document).on("mouseenter.tooltip focusin.tooltip", ".using-tooltip, .input-validation-error", function () {
                var TooltipID = Common.TooltipID++;
                var Container = this;
                var $Container = $(this);
                var Title;
                if (Container.hasClass("og-button-ui-action") && $(".og-button-ui-action-text", this).length > 0 && $(".og-button-ui-action-text:visible", this).length != 0)
                    Title = null;
                else if (Container.getAttribute("title") && Container.getAttribute("title").length > 0) {
                    Title = Container.getAttribute("title");
                    $Container.attr("data-title", Title);
                    Container.removeAttribute("title");
                }
                else if (Container.getAttribute("data-title"))
                    Title = Container.getAttribute("data-title");
                else if (Container.hasClass("input-validation-error"))
                    Title = $Container.next(".field-validation-error").text();
                if (Title == null || Title == "")
                    return true;

                var $Tooltip = $
                    (document.createElement('div')
                        .addClass("tooltip", "tooltip-in"))
                    .append(document.createElement('div').addClass("tooltip-arrow"))
                    .append($
                        (document.createElement('div')
                            .addClass("tooltip-inner"))
                        .html(Title.replace(/\n/g, '<br />')))
                    .appendTo(document.body);
                if (Container.hasClass("using-tooltip-bottom"))
                    $Tooltip[0].addClass("tooltip-bottom");
                else if (Container.hasClass("using-tooltip-far"))
                    $Tooltip[0].addClass("tooltip-far");
                else
                    $Tooltip[0].addClass("tooltip-top");

                $(window).on("scroll.tooltip_" + TooltipID, function () {
                    if (!$.contains(document.documentElement, Container))
                        return;

                    var Offset = $Container.offset();
                    var Left;
                    if (Container.hasClass("using-tooltip-far")) {
                        if (Common.IsRightToLeft())
                            Left = Offset.left - $Tooltip.outerWidth();
                        else
                            Left = Offset.left + $Container.outerWidth();
                    }
                    else {
                        Left = Offset.left + $Container.outerWidth() / 2 - $Tooltip.outerWidth() / 2;
                        if (Left < 0) {
                            Left = Offset.left;
                            $Tooltip.find(".tooltip-arrow").css("left", $Container.outerWidth() / 2);
                        }
                        else if (Left + $Tooltip.outerWidth() > $(window).outerWidth()) {
                            Left = Offset.left + $Container.outerWidth() - $Tooltip.outerWidth();
                            $Tooltip.find(".tooltip-arrow").css("left", $Tooltip.outerWidth() - $Container.outerWidth() / 2);
                        }
                    }

                    var Top;
                    if (Container.hasClass("using-tooltip-far"))
                        Top = Offset.top + $Container.outerHeight() / 2 - $Tooltip.outerHeight() / 2;
                    else if ($Container.hasClass("using-tooltip-bottom"))
                        Top = Offset.top + $Container.outerHeight();
                    else
                        Top = Offset.top - $Tooltip.outerHeight();
                    if (Top < 0)
                        $Tooltip.remove();

                    $Tooltip.css("left", Left + "px")
                        .css("top", Top + "px");
                }).trigger("scroll.tooltip_" + TooltipID);

                $Container.one("mouseleave.tooltip focusout.tooltip", function () {
                    $Tooltip.removeClass("tooltip-in");
                    setTimeout(function () {
                        $Tooltip.remove();
                        $(window).off("scroll.tooltip_" + TooltipID);
                    }, 1000);
                });
                return true;
            });
        }
        static Tooltip_PageLoad(): void {
            Common.Tooltip_Hide();
        }
        static Tooltip_Hide(): void {
            $(".tooltip").remove();
        }

        static AjaxRequest(Parameters: AjaxRequestParameters): void {
            if (Parameters.ShowLoading == null)
                Parameters.ShowLoading = true;
            if (Parameters.Method == null)
                Parameters.Method = "POST";
            if (Parameters.ShowLoading)
                Navigation.Loading_Show();
            if (Parameters.ContentType == null && Parameters.Data != null)
                Parameters.ContentType = "application/json";

            var Data = Parameters.Data;
            if (Data != null && typeof (Data) != "string" && !(Data instanceof FormData))
                Data = JSON.stringify(Data);
            $.ajax({
                url: Parameters.URL,
                data: Data,
                contentType: Parameters.ContentType,
                processData: Parameters.ProcessData,
                type: Parameters.Method,
                success: function (Response) {
                    Common.AjaxSuccess(Response, Parameters.ShowLoading, Parameters.SuccessMethod, Parameters.ErrorMethod);
                },
                error: function (Request, Status, Exception) {
                    if (Parameters.URL == "/error_javascript/")
                        return;
                    if (Parameters.RetriesPending != null && Parameters.RetriesPending > 0) {
                        Parameters.RetriesPending--;
                        setTimeout(function () {
                            Common.AjaxRequest(Parameters);
                        }, 1000);
                        return;
                    }
                    if (Parameters.SkipAjaxErrorMethod != true)
                        Common.AjaxError(Request, Status, Exception);
                    if (Parameters.ErrorMethod != null)
                        Parameters.ErrorMethod();
                    if (Parameters.ShowLoading)
                        Navigation.Loading_Hide();
                }
            });
        }
        static AjaxSuccess(Response, HideLoading, SuccessMethod, ErrorMethod?): void {
            if (Response != null && typeof (Response) != "undefined" && typeof (Response.ErrorMessage) != "undefined" && Response.ErrorMessage.length > 0) {
                Modals.ShowMessageDialog(Response.ErrorTitle == null ? "ארעה שגיאה" : Response.ErrorTitle, Response.ErrorMessage, Response.ErrorButton);
                if (ErrorMethod != null)
                    ErrorMethod();
                if (HideLoading)
                    Navigation.Loading_Hide();
                return;
            }

            if (typeof (Response) != "string" && Response.RedirectURL !== undefined) {
                var IsRefresh = Response.RedirectURL == ".";
                if (IsRefresh)
                    Response.RedirectURL = window.location.href;

                if (Response.CloseModal) {
                    Modals.HideAll(false, function () {
                        if (IsRefresh)
                            Response.RedirectURL = window.location.href;

                        if (Response.FullRefresh)
                            window.location.href = Response.RedirectURL;
                        else
                            Navigation.Redirect(Response.RedirectURL, Response.AllowRedirectModal == false);
                    });
                    if (HideLoading)
                        Navigation.Loading_Hide();
                }
                else if (Response.FullRefresh)
                    window.location.href = Response.RedirectURL;
                else {
                    Navigation.Redirect(Response.RedirectURL, Response.AllowRedirectModal == false);
                    if (HideLoading)
                        Navigation.Loading_Hide();
                }
                return;
            }
            if (typeof (Response) != "string" && Response.Notifications != null) {
                setTimeout(function () {
                    Notifications.Show(Response.Notifications);
                }, 200);
            }
            if (SuccessMethod != null)
                SuccessMethod(Response);
            if (HideLoading)
                Navigation.Loading_Hide();
        }
        static AjaxError(Request, Status, Exception, HideLoading = false): void {
            if (HideLoading)
                Navigation.Loading_Hide();

            if (Request.readyState == 0 && Request.status == 0)
                Modals.ShowMessageDialog("ארעה שגיאת תקשורת", "מומלץ לבדוק כי חיבור האינטרנט תקין, ולנסות לבצע את הפעולה מחדש.<br />במידה והשגיאה חוזרת על עצמה, אנא שלחו לנו פנייה באמצעות טופס <a href=\"/help/support/\">יצירת קשר</a> או בדוא\"ל <a target=\"_blank\" href=\"mailto:support@sumit.co.il\">support@sumit.co.il</a>.");
            else if (Request.readyState == 0 || Request.status == 0)
                return;
            else if (Request.responseJSON && Request.responseJSON.ErrorMessage)
                Modals.ShowMessageDialog("ארעה שגיאה " + Request.responseJSON.ErrorCode, Request.responseJSON.ErrorMessage);
            else
                Modals.ShowMessageDialog("ארעה שגיאה", Status + ",\r\n" + Exception + ",\r\n" + Request.responseText);
        }

        // Keep here for old mobile apps
        static Loading_Show() {
            return Navigation.Loading_Show();
        }
        static Loading_Hide() {
            return Navigation.Loading_Hide();
        }

        static ConvertArrayToNumbers(Values): Number[] {
            var ToReturn = new Array();
            for (var i = 0; i < Values.length; i++)
                ToReturn.push(new Number(Values[i]));
            return ToReturn;
        }

        static SetIsNotRobot(): void {
            $("input[name=IsNotRobot]").val("true");
        }

        static ShowBelow($Element, $BelowElement) {
            if ($Element.is(":visible")) {
                //Element.stop(true).fadeOut(200);
                return;
            }
            $Element.data("ShowBelow_OriginalParent", $Element.parent());

            $(document.body).append($Element);

            Teva.Positioning.PositionBelow($Element, $BelowElement);

            $Element.css("position", "absolute");
            $Element.fadeIn(200);

            var AlignToLeft = false;
            if (document.body.dir == "ltr")
                AlignToLeft = !AlignToLeft;
            $Element.stop(true).fadeIn(200);

            $(window).on("resize.showbelow", function () {
                Teva.Positioning.PositionBelow($Element, $BelowElement);
            });

            $(document).on("mousedown.showbelow", function (Event) {
                if ($(Event.target).closest($Element).length != 0)
                    return;
                if ($(Event.target).closest('.teva-datepicker').length != 0)
                    return;

                Common.ShowBelow_Rollback($Element);
            });
        }
        static ShowBelow_Rollback($Element) {
            $Element.stop(true).fadeOut(200, function () {
                var $OriginalParent = $($Element.data("ShowBelow_OriginalParent"));
                $OriginalParent.append($Element);
            });
            $(document).off("mousedown.showbelow");
            $(window).off("resize.showbelow");
        }

        static ShortWithDots(Text: string, MaximumLength: number) {
            if (Text != null && Text.length > MaximumLength && MaximumLength > 3)
                return Text.substring(0, MaximumLength - 3) + "...";
            else
                return Text;
        }

        static GetDownloadIdentifierCookie() {
            return Math.round(Math.random() * 100000000000);
        }

        static Clipboard_Set(Text, Message) {
            if (Message == null)
                Message = "הקישור הועתק בהצלחה"
            try {
                var $CodeBlock = $(document.createElement('textarea'))
                    .css("width", "1px")
                    .css("height", "1px")
                    .html(Text)
                    .appendTo(document.body)
                    .select();
                document.execCommand("copy");
                $CodeBlock.blur();
                $CodeBlock.remove();
                Notifications.Show([{
                    Text: Message
                }]);
            }
            catch (E) {
                alert("ההעתקה נכשלה, אנא בצע את ההעתקה באמצעות Ctrl+C");
            }
            return false;
        }

        static CodeBlock_Copy($Link) {
            var Code = $Link.closest(".codeblock, .urlblock").find(".codeblock-code, .urlblock-code").text();
            Common.Clipboard_Set(Code, "הקוד הועתק בהצלחה");
            return false;
        }

        static $NavigationAddressPickerModal;
        static ShowNavigationAddressPicker($Input) {
            var $Container = $Input.closest(".navigation-address");
            Common.$NavigationAddressPickerModal = OfficeGuy.Modals.ShowURLModal("/crm/navigationaddresspicker/");
            Common.$NavigationAddressPickerModal.data("Container", $Container);

            return false;
        }
        static NavigationAddressPicker_Select(Text, PlaceID, Latitude, Longitude) {
            if (Common.$NavigationAddressPickerModal == null)
                return false;

            var $Container = $(Common.$NavigationAddressPickerModal.data("Container"));
            $Container.find(".navigation-address-text").val(Text);
            $Container.find(".navigation-address-hidden").val(JSON.stringify({
                Text: Text,
                PlaceID: PlaceID,
                Latitude: Latitude,
                Longitude: Longitude
            })).trigger("change");
            Modals.Hide(Common.$NavigationAddressPickerModal, true);
            return false;
        }

        static IsiOS(): boolean {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i) != null;
        }
        static IsMobileDevice(): boolean {
            var Android = function () {
                return navigator.userAgent.match(/Android/i) != null;
            };
            var BlackBerry = function () {
                return navigator.userAgent.match(/BlackBerry/i) != null;
            };
            var Opera = function () {
                return navigator.userAgent.match(/Opera Mini/i) != null;
            };
            var Windows = function () {
                return navigator.userAgent.match(/IEMobile/i) != null;
            };
            return Android() || BlackBerry() || Common.IsiOS() || Opera() || Windows();
        }
        static FormatWhatsappPhoneNumber(Value) {
            var ToReturn = "";
            for (var i = 0; i < Value.length; i++) {
                if (Value[i] >= '0' && Value[i] <= '9')
                    ToReturn += Value[i];
            }
            if (ToReturn.indexOf("05") == 0)
                ToReturn = "972" + ToReturn.substring(1);
            if (ToReturn.indexOf("9725") != 0)
                return "";
            return ToReturn;
        }

        static FormatString(Content: string, Arguments: string[]) {
            for (var i = 0; i < Arguments.length; i++)
                Content = Content.replace('{' + i + '}', Arguments[i]);
            return Content;
        };

        static RoundTwoPoints(Value: number): number {
            var Result = Common.RoundEven(Value, 2);
            if (Result == -0)
                Result = 0;
            return Result;
        }
        static RoundFourPoints(Value: number): number {
            var Result = Common.RoundEven(Value, 4);
            if (Result == -0)
                Result = 0;
            return Result;
        }
        static RoundEven(Value, DecimalPlaces) {
            var d = DecimalPlaces || 0;
            var m = Math.pow(10, d);
            var n = +(d ? Value * m : Value).toFixed(8); // Avoid rounding errors
            var i = Math.floor(n), f = n - i;
            var e = 1e-8; // Allow for rounding errors in f
            var r = (f > 0.5 - e && f < 0.5 + e) ? ((i % 2 == 0) ? i : i + 1) : Math.round(n);
            return d ? r / m : r;
        }

        static LandingPages_Comment() {
            if ((<string>$("textarea.og-comment-text").val()).length == 0)
                return;

            Common.AjaxRequest({
                URL: "/_comment/",
                Data: {
                    CompanyID: $("input.og-comment-companyid").val(),
                    PageID: $("input.og-comment-pageid").val(),
                    FullName: $("input.og-comment-fullname").val(),
                    Text: $("textarea.og-comment-text").val(),
                    URL: window.location.href
                },
                SuccessMethod: function () {
                    $(".og-comment-newcomment").hide();
                    $(".og-comment-commented").show();
                }
            });
        }

        static FileChangedShowPreview(FileElement: HTMLInputElement): void {
            var $Hidden = $("input:hidden", $(FileElement).nextAll("div:first"));
            if (FileElement.files && FileElement.files[0])
                $Hidden.attr("disabled", "disabled");
            else
                $Hidden.attr("disabled", $Hidden.prevAll("input:checkbox").prop("checked") ? "disabled" : null);

            var $PreviewElement = $("#" + FileElement.name + "_Preview");
            if ($PreviewElement.length == 0)
                return;

            if (FileElement.files && FileElement.files[0] && FileElement.files[0].type.match('image.*')) {
                var Reader = new FileReader();
                Reader.readAsDataURL(FileElement.files[0]);

                Reader.onload = function (e: any) {
                    (<any>$PreviewElement[0]).src = e.target.result;
                    $PreviewElement.css("display", "block");
                };
            }
            else
                $PreviewElement.hide();
        }

        static InitBottomFade($Container?) {
            var $MainInner = $("#main-inner");

            $(window)
                .off("scroll.sumit-fade, resize.sumit-fade")
                .on("scroll.sumit-fade, resize.sumit-fade", function () {
                    if (document.body && window.scrollY + document.body.clientHeight < document.body.scrollHeight - 25)
                        $MainInner.addClass("sumit-fade-bottom-visible");
                    else
                        $MainInner.removeClass("sumit-fade-bottom-visible");
                })
                .trigger("resize.sumit-fade");

            $(".sumit-fade-bottom", $Container)
                .on("scroll.sumit-fade", function () {
                    if (this.scrollTop + this.clientHeight < this.scrollHeight - 25)
                        this.addClass("sumit-fade-bottom-visible");
                    else
                        this.removeClass("sumit-fade-bottom-visible");
                })
                .trigger("scroll.sumit-fade").addClass("sumit-fade-bottom-init");

            $MainInner.addClass("sumit-fade-bottom sumit-fade-bottom-init");
        }

        static MigratePopup() {
            var NextMigratePopupDate = Teva.Storage.LocalStorage_Get("NextMigratePopupDate", true);
            if (NextMigratePopupDate != null)
                NextMigratePopupDate = new Date(NextMigratePopupDate);
            if (NextMigratePopupDate == null) {
                NextMigratePopupDate = new Date();
                NextMigratePopupDate.setDate(NextMigratePopupDate.getDate() + 1);
                Teva.Storage.LocalStorage_Set("NextMigratePopupDate", NextMigratePopupDate, true);
            }
            else if (NextMigratePopupDate < new Date()) {
                OfficeGuy.Modals.ShowURLModal('/actionsbilling/migrate/');
                NextMigratePopupDate = new Date();
                NextMigratePopupDate.setDate(NextMigratePopupDate.getDate() + 7);
                Teva.Storage.LocalStorage_Set("NextMigratePopupDate", NextMigratePopupDate, true);
            }
        }
    }
}

(function ($) {
    function visible(element) {
        return $.expr.pseudos.visible(element) && !$(element).parents().addBack().filter(function () {
            return (<any>$).css(this, 'visibility') === 'hidden';
        }).length;
    }

    function focusable(element, isTabIndexNotNaN) {
        var map, mapName, img, nodeName = element.nodeName.toLowerCase();
        if ('area' === nodeName) {
            map = element.parentNode;
            mapName = map.name;
            if (!element.href || !mapName || map.nodeName.toLowerCase() !== 'map') {
                return false;
            }
            img = $('img[usemap=#' + mapName + ']')[0];
            return !!img && visible(img);
        }
        return (/input|select|textarea|button|object/.test(nodeName) ?
            !element.disabled :
            'a' === nodeName ?
                element.href || isTabIndexNotNaN :
                isTabIndexNotNaN) &&
            // the element and all of its ancestors must be visible
            visible(element);
    }

    $.extend($.expr.pseudos, {
        focusable: function (element) {
            return focusable(element, !isNaN((<any>$).attr(element, 'tabindex')));
        }
    });
})(jQuery);

declare let SignaturePad: any;